export default __webpack_public_path__ + "static/media/sister-abocgo.c7e1e6ff.png";